import React, { useState, ChangeEvent, FocusEvent } from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { TextFieldProps } from '@material-ui/core';

interface FirstNameInputProps {
  value: string;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  errorsArr: string[];
  setErrorsArr: React.Dispatch<React.SetStateAction<string[]>>;
}

const FirstNameInput: React.FC<FirstNameInputProps> = ({
  value, 
  handleChange, 
  errorsArr, 
  setErrorsArr
}) => {
  const [error, setError] = useState<boolean>(false);
  const [helperText, setHelperText] = useState<string>('');

  const validateFirstName = (name: string): void => {
    if (name.length < 2) {
      setError(true);
      const tempErrorsArr = errorsArr.filter(i => i !== 'firstName');
      setErrorsArr([...tempErrorsArr, "firstName"]);
      setHelperText("Please provide a first name of two characters or more.");
      return;
    } 
    
    setError(false);
    setHelperText(""); 
    const tempErrorsArr = errorsArr.filter(i => i !== 'firstName');
    setErrorsArr([...tempErrorsArr]);    
  };

  return (
    <Grid item xs={12}>
      <TextField
        autoComplete="given-name"
        name="firstName"
        variant="outlined"
        value={value}
        required
        fullWidth
        id="firstName"
        label="First Name"
        error={error}
        helperText={helperText}
        onChange={handleChange}
        onBlur={(e: FocusEvent<HTMLInputElement>) => validateFirstName(e.target.value)}
        autoFocus
      />
    </Grid>
  );
};

export default FirstNameInput;